<script>
  import { Router, Link, Route } from 'svelte-navigator';
  import RouteTransition from '../RouteTransition.svelte';
  import { fly, blur } from 'svelte/transition';
  import Paths from '../Utils/Paths.svelte';

  import {
    idTrappe,
    type,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    couleur,
  } from '../stores.js';

  import ChoixTrappe from '../Pages/ChoixTrappe.svelte';
  import TitleNNumber from '../ComponentsInProcess/TitleNNumber.svelte';
  import BtnPage from '../ComponentsInProcess/btnPageMetalique.svelte';
  import BtnPageAluHydro from '../ComponentsInProcess/BtnPageAluHydro.svelte';
  import RangeSliderAluHydro from '../ComponentsInProcess/range-slider-2-alu-hydro.svelte';
  export let idFiche;
  console.log(`idFiche ${idFiche}`);
</script>

<!--
     https://simeydotme.github.io/svelte-range-slider-pips/ 
Pipstep calculation to split by 4 :
    ((slider1Max - slider1Min) / slider1Step) / 4
    if result in not an integer, the slider will glitch
-->
<!-- <RangeSliderAluHydro
  idFiche="{idFiche}"
  slider1Pipstep="29" 
  slider1Step="50"
  slider1Min="200"
  slider1Max="6000"
  slider2Step="50"
  slider2Min="200"
  slider2Max="6000"
/> -->

{#if idFiche == 1}
  <Paths />
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageAluHydro idFiche="{idFiche}" idBtn="1" titre="{'Mur'}" />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageAluHydro idFiche="{idFiche}" idBtn="2" titre="{'Plafond'}" />
    </div>
  </div>
{:else if idFiche == 2}
  <Paths />
  <div in:fly="{{ x: 100, duration: 800 }}">
    <!--
     https://simeydotme.github.io/svelte-range-slider-pips/ 
Pipstep calculation to split by 4 :
    ((slider1Max - slider1Min) / slider1Step) / 4
    if result in not an integer, the slider will glitch
-->
    <RangeSliderAluHydro
      idFiche="{idFiche}"
      slider1Pipstep="29"
      slider1Step="50"
      slider1Min="200"
      slider1Max="6000"
      slider2Pipstep="5"
      slider2Step="50"
      slider2Min="200"
      slider2Max="1200"
    />
  </div>
{:else if idFiche == 3}
  <Paths />
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageAluHydro
        idFiche="{idFiche}"
        idBtn="3"
        titre="{'Sur le côté de ' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageAluHydro
        idFiche="{idFiche}"
        idBtn="4"
        titre="{'Sur le côté de ' + $dimLargeur + ' mm'}"
        soustitre=""
      />
    </div>
  </div>
{:else if idFiche == 4}
  <Paths />
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageAluHydro
        idBtn="5"
        idFiche="{idFiche}"
        titre="{'Pousser / Lâcher'}"
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageAluHydro idBtn="6" idFiche="{idFiche}" titre="{'Clé carrée'}" />
    </div>
    <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
      <BtnPageAluHydro
        idBtn="7"
        idFiche="{idFiche}"
        titre="{'Clé boite aux lettres'}"
      />
    </div>
  </div>
{:else if idFiche == 5}
  <Paths />
  <!-- <div in:fly="{{ x: 100, duration: 800 }}">
    <BtnPageAluHydro idBtn="8" idFiche="{idFiche}" titre="{'Blanc'}" />
  </div>
  <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
    <BtnPageAluHydro idBtn="9" idFiche="{idFiche}" titre="{'Blanc Mat'}" />
  </div>
  <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
    <BtnPageAluHydro idBtn="10" idFiche="{idFiche}" titre="{'Personalisée'}" />
  </div> -->
{/if}
